<template>
  <div class="flex items-stretch h-full">
    <div class="hidden md:flex w-2/4 bg-staticprimary dark:bg-staticprimary-900 text-xs relative">
      <img
        class="object-cover mix-blend-soft-light filter grayscale"
        src="@/assets/img/aside-image.webp"
        alt="aside"
      />
      <div class="absolute bottom-4 left-0 w-full z-10 text-white">
        <div class="p-8 hidden">
          <h2 class="text-4xl font-bold mb-2">EdasInvoiZE</h2>
          <h3 class="text-xl font-medium opacity-80">
            ZeroComa
          </h3>
        </div>
      </div>
    </div>
    <div class="w-full flex flex-col min-h-full">
      <div class="main flex-grow">
        <slot name="main" />
      </div>
      <div class="flex-shrink-0 h-10 flex items-center justify-center dark:bg-staticdarkblue-900">
        <copy-legal />
      </div>
    </div>
  </div>
</template>

<script>
import CopyLegal from '@/components/CopyLegal.vue'
export default {
  name: 'public-layout',
  props: {
    asideData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CopyLegal
  }
}
</script>
